import type { ScoreComponents } from '../../../types/preplanning';

type ScoreWeights = { distance: number; workload: number; profitability: number; driver_score?: number };

/** The planner's preference multipliers, in the order the breakdown lists them
 * (planner feedback, 2026-10-29): a preferred location in the move's scope, and a
 * delivery of the live/drop style the driver prefers. */
const BOOSTS: [keyof ScoreComponents, string][] = [
  ['preferred_location', 'Preferred location'],
  ['live_preference', 'Live/drop preference'],
];

/** Each lift the driver's preferences gave the match. Empty when none applied, or on
 * a plan built before the planner recorded them. */
export function scoreBoosts(components: ScoreComponents): { label: string; factor: number }[] {
  return BOOSTS.flatMap(([key, label]) => {
    const factor = components[key];
    return factor !== undefined && factor > 1 ? [{ label, factor }] : [];
  });
}

/** The match score as the planner computes it: the weighted parts, times every
 * preference lift. A lifted score can pass 100%. */
export function weightedScore(components: ScoreComponents, weights: ScoreWeights): number {
  const sum = components.distance * weights.distance
    + components.workload * weights.workload
    + components.profitability * weights.profitability
    + (components.driver_score ?? 0.5) * (weights.driver_score || 0.20);
  return scoreBoosts(components).reduce((score, boost) => score * boost.factor, sum);
}
